import classNames from 'classnames';
import _ from 'lodash';
import { useEffect, useMemo, useRef } from 'react';
import './DocUploadProgress.css';

const labelOffset = 20; //percent

export type ProgressProps = {
  text?: string;
  value?: number;
};

export const DocUploadProgress = ({ text, value }: ProgressProps) => {
  const indicatorRef = useRef<HTMLElement>(null);

  const percent = useMemo(() => {
    if (_.isNil(value) || value < 0) return undefined;
    const result = Math.ceil(value * 100);
    return result <= 100 ? result : 100;
  }, [value]);

  useEffect(() => {
    const percentFraction = (percent ?? 0) / 100;
    const progresPercent = labelOffset + (100 - labelOffset) * percentFraction;
    indicatorRef.current?.style.setProperty(
      '--progress-percent',
      `${progresPercent}%`,
    );
  }, [percent]);

  const uploadText = useMemo(
    () => (_.isNil(text) ? '' : `${text} ${percent}%`),
    [percent, text],
  );

  return (
    <>
      <div
        className={classNames('doc-upload-progress__container', {
          'doc-upload-progress__hide': !!percent,
        })}
      >
        <span className="doc-upload-progress__body">
          <span ref={indicatorRef} className="doc-upload-progress__progress-bar" />
          {uploadText}
        </span>
      </div>
    </>
  );
};
